/**
 * Switch to imperial when in metric, and vice versa.
 * @param {Object} camera - Current camera.
 * @param {Object} action - Details of the current request.
 * @return {Object} Updated camera with the unit of measurement switched.
*/

export default function updateName(camera, value) {
  return Object.assign({}, camera, {
    name: value
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateName.js